<template>
  <div class="dashboard-tab-root">
    <div class="dashboard-mybalance">
      <!-- Total Income -->
      <div class="todayincome-title" @click="handleJumpInviteDetail">
        {{ $t('lang.mybean.totalIncome') }}
        <div class="income-beans">
          <img class="beans-icon" :src="getMatchImg('beans')" />
          {{ info.agentSumBean }}
        </div>
        <img class="icon-arrow-r ar-arrow" src="../images/arrow-r.png" />
      </div>

      <!-- My Balance -->
      <div class="dashboard-mybalance-title">{{ $t('lang.wd.myBalance') }}</div>
      <div class="withdraw-info">
        <div class="withdraw-info-beans">
          <img :src="getMatchImg('beans')" />
          <i class="beans-count">{{ info.walletBean }}</i>
          <i class="beans-price">
            ≈
            <i style="font-family: 'Inter-Regular'">{{ info.currencyCode }}</i>
            {{ numberTransformK(info.currencyAmount / 100, info.locationCode) }}
          </i>
        </div>
        <div class="withdraw-info-btn" @click="handleWithdraw">{{ $t('lang.sevenKeepSignin.withdraw') }}</div>
      </div>
    </div>

    <div class="week-commission">
      <!-- This Week Commission -->
      <div id="invite-target-dd" class="tit-tips">
        <div class="tit-tips-title">{{ $t('lang.dl.commission') }}</div>
        <div class="tit-tips-tips" @click="toRules">
          {{ $t('lang.newInvite.k012') }}
          <img src="../images/rules-tips2.png" />
        </div>
        <div class="beans-got">
          {{ info.weekAgentCommissionBeans }}
          <img :src="getMatchImg('beans')" />
        </div>
      </div>
      <div class="percent-bar" id="invite-target-cc">
        <PercentBar :percentCount="info.weekHostEarningBeans" :earnTypeList="info.commissionLevelList"></PercentBar>
      </div>
      <!-- vlolation-deduction -->
      <div class="vlolation-deduction" @click="toViolationDetails">
        {{ $t('lang.newInvite.k013') }}
        <div>
          <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
          <span>{{ info.weekHostDeductionBeans || 0 }}</span>
          <img class="arrow-icon ar-arrow" src="../images/arrow-r.png" alt="" />
        </div>
      </div>
    </div>

    <div class="invite-list">
      <div class="invite-title">{{ $t('lang.newInvite.k066') }}</div>
      <div class="switch-tab">
        <div class="tab" :class="{ 'active-tab': inviteTabIndex == 1 }" @click="handelInviteTab(1)">{{ $t('lang.dl.thisWeek') }}</div>
        <div class="tab" :class="{ 'active-tab': inviteTabIndex == 2 }" @click="handelInviteTab(2)">{{ $t('lang.host.lastWeek') }}</div>
        <div class="tab" :class="{ 'active-tab': inviteTabIndex == 0 }" @click="handelInviteTab(0)">{{ $t('lang.all') }}</div>
      </div>

      <div class="amount-block" id="invite-target-aa">
        <div class="amount-item">
          <div class="amount-title">{{ $t('lang.dl.totalHostess') }}</div>
          <span class="amount-count">{{ totalHostess }}</span>
        </div>

        <div class="amount-item">
          <div class="amount-title">{{ $t('lang.inRule.inviteBonus') }}</div>
          <span class="amount-count">
            <img :src="getMatchImg('beans')" />
            {{ inviteBonus }}
          </span>
        </div>
      </div>
    </div>

    <div style="height: 250px"></div>

    <!-- 新手指导 -->
    <div class="newguy-guide" id="guide-step1" @click="handleGuideClick(1)">
      <div class="step1">
        <div class="btn-wrap">
          <div class="newguy-guide-btn">
            <div @click="handleGuideClick(1)">{{ $t('lang.base.Next') }}</div>
          </div>
        </div>

        <div class="newguy-guide-percent" id="invite-guide-cc">
          <PercentBar
            :percentCount="10000"
            :earnTypeList="[
              {
                minBeans: 0,
                levelRate: 5
              },
              {
                minBeans: 100000,
                levelRate: 8
              },
              {
                minBeans: 100000,
                levelRate: 8
              },
              {
                minBeans: 10000000,
                levelRate: 20
              }
            ]"
          ></PercentBar>
        </div>

        <div class="newguy-guide-tips">
          <div class="tips-content">
            <p class="tips-title right-align">{{ $t('lang.newInvite.k045') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="newguy-guide" id="guide-step2" @click="handleGuideClick(2)">
      <div class="step2">
        <div class="btn-wrap">
          <div class="newguy-guide-btn">
            <div @click="handleGuideClick(2)">{{ $t('lang.base.Next') }}</div>
          </div>
        </div>

        <div class="week-commission">
          <div class="tit-tips" id="invite-guide-dd">
            <div class="tit-tips-title">{{ $t('lang.dl.commission') }}</div>
            <div class="tit-tips-tips">
              {{ $t('lang.newInvite.k012') }}
              <img src="../images/rules-tips2.png" />
            </div>
            <div class="beans-got">
              500
              <img :src="getMatchImg('beans')" />
            </div>
          </div>
        </div>

        <div class="newguy-guide-tips">
          <div class="tips-content">
            <div class="tips-title right-align">{{ $t('lang.newInvite.k047') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberTransformK } from '@/utils/common'
import { tabEnmu } from '../utils/enum'
import { apiFetchMyInvite } from '@/api/imee'

import PercentBar from './PercentBar.vue'
import TipOnclick from '@/components/TipOnclick/index.vue'

export default {
  components: { PercentBar, TipOnclick },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      }
    }
  },
  data() {
    return {
      inviteTabIndex: 0,
      loading: false,
      hosts: [],
      totalHostess: 0,
      inviteBonus: 0
    }
  },
  methods: {
    numberTransformK: numberTransformK,
    handleWithdraw() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'withdraw' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({
        path: '/withdrawal',
        query: { fromPage: 'invite-v2', walletType: 1 }
      })
    },
    handleJumpInviteDetail() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'details' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({ path: '/invite-history', query: { fromPage: 'invite-v2' } })
    },
    toRules() {
      window.sessionStorage.setItem('agentCenterTabIndex', tabEnmu.dashboard)
      this.$router.push({ path: '/invite-v2-rules', query: { fromPage: 'invite-v2', location: 'commission' } })
    },
    toViolationDetails() {
      window.sessionStorage.setItem('agentCenterTabIndex', tabEnmu.dashboard)
      this.$router.push({ path: '/violation-details', query: { fromPage: 'invite-v2' } })
    },
    handleGuideClick(arg) {
      this.$emit('stepChange', `step${arg + 1}`)
    },
    handleCopyId(item) {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.handleCopy(item.presentId, this.$t('lang.msgCopySuccss'))
    },
    fetchMyInvite(val) {
      if (this.loading) return
      this.loading = true
      apiFetchMyInvite({ timeType: val, limit: 10, offset: 0 })
        .then((res) => {
          if (res && !res.error && val === this.inviteTabIndex) {
            this.totalHostess = res.total || 0
            this.inviteBonus = res.inviteBonusBeans || 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handelInviteTab(arg) {
      this.inviteTabIndex = arg
      this.hosts = []
      this.loading = false
      this.fetchMyInvite(this.inviteTabIndex)
    }
  },
  created() {
    this.handelInviteTab(1)
    document.body.addEventListener('click', this.hideTips)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.hideTips)
  }
}
</script>
<style lang="scss" scoped>
.dashboard-tab-root {
  .dashboard-mybalance {
    width: 343px;
    margin: auto;
    padding: 0 12px 16px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;

    .dashboard-mybalance-title {
      height: 18px;
      font-family: 'RobotoFlex-Regular';
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      margin-top: 12px;
    }

    .withdraw-info {
      padding: 8px 0 0;
      width: 100%;
      position: relative;
      .withdraw-info-beans {
        flex: 1;
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        img {
          width: 25px;
          height: 25px;
        }
        .beans-count {
          margin-left: 4px;
          font-family: 'RobotoFlex-Regular';
          font-weight: bold;
          font-size: 30px;
          color: #333333;
          line-height: 36px;
          text-align: left;
        }
        .beans-price {
          margin-left: 4px;
          font-family: 'RobotoFlex-Regular';
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          line-height: 30px;
          text-align: left;
          font-style: normal;
        }
      }
      .withdraw-info-btn {
        width: 100%;
        line-height: 36px;
        margin: 0 auto;
        background: var(--dashboard-withdraw-btn-bg);
        border-radius: 24px;
        font-family: 'RobotoFlex-Regular';
        font-weight: normal;
        font-size: 15px;
        color: var(--dashboard-withdraw-btn-color);
        text-align: center;
        margin-top: 19px;
      }
    }

    .todayincome-title {
      width: 100%;
      font-family: 'RobotoFlex-Regular';
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      padding: 12px 0;
      display: inline-flex;
      align-items: center;
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 1px;
        background: #ededed;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .income-beans {
        flex: 1;
        height: 18px;
        font-family: 'RobotoFlex-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .beans-icon {
          width: 15px;
          height: 15px;
          margin-right: 4px;
        }
      }
      .icon-arrow-r {
        width: 12px;
        height: 12px;
        margin-left: 4px;
      }
    }
  }

  .week-commission {
    width: 343px;
    background: #ffffff;
    border-radius: 8px;
    margin: 16px auto 16px;
    position: relative;
    padding: 0 15px;
    .tit-tips {
      padding-bottom: 10px;
      .tit-tips-title {
        font-family: 'RobotoFlex-Regular';
        font-size: 19px;
        font-weight: bold;
        color: #333333;
        padding: 12px 0;
      }
      .tit-tips-tips {
        font-family: 'RobotoFlex-Regular';
        font-size: 15px;
        color: #333333;
        line-height: 16px;
        padding: 0 0 6px;
        display: flex;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin: 0 3px;
        }
      }
      .beans-got {
        width: 100%;
        text-align: center;
        font-family: 'RobotoFlex-Regular';
        font-weight: 900;
        font-size: 20px;
        color: var(--dashboard-beans-got);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 4px;

        img {
          width: var(--commission-beans-icon-size);
          height: var(--commission-beans-icon-size);
          margin: var(--commission-beans-icon-margin);
        }
      }
    }
    .percent-bar {
      margin: 0 auto;
    }
    .vlolation-deduction {
      line-height: 18px;
      margin: 16px auto;
      padding: 12px 0;
      border-top: 1px solid #ededed;
      font-family: 'RobotoFlex-Regular';
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .beans-icon {
        width: 14px;
        height: 14px;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        display: inline-block;
        vertical-align: middle;
        margin: 0 4px;
      }

      .arrow-icon {
        width: 12px;
        height: 12px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    // hostess
    .deliver-line {
      width: 319px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }
  }

  .invite-list {
    width: 343px;
    background: #ffffff;
    border-radius: 8px;
    margin: 16px auto 0;
    padding: 0 15px;
    padding-bottom: 24px;
    .invite-title {
      font-family: 'RobotoFlex-Regular';
      font-size: 19px;
      font-weight: bold;
      color: #333333;
      padding: 12px 0;
    }

    .switch-tab {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 3px 2px;
      border-radius: 4px;
      background-color: #fafafa;

      .tab {
        flex: 1;
        min-height: 26px;
        line-height: 26px;
        font-family: 'RobotoFlex-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #b2b2b2;
        text-align: center;

        &.active-tab {
          color: #333333;
          background: #ffffff;
          position: relative;
          font-weight: bold;
          border-radius: 4px;
          // &::after {
          //   content: '';
          //   position: absolute;
          //   left: 50%;
          //   bottom: 0;
          //   width: 35px;
          //   height: 2px;
          //   margin-left: -17.5px;
          //   background-color: #333333;
          // }
        }
      }
    }

    .amount-block {
      overflow: hidden;
    }

    .amount-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;

      .amount-title {
        font-family: 'RobotoFlex-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        line-height: 18px;
      }

      .amount-count {
        font-family: 'RobotoFlex-Regular';
        font-weight: 400;
        font-size: 15px;
        color: var(--invite-tab-theme-color);
        display: flex;
        align-items: center;

        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-right: 4px;
        }
      }
    }
  }

  .newguy-guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -999;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.7);

    .newguy-guide-btn {
      min-width: 72px;
      height: 30px;
      padding: 0 10px;
      border-radius: 20px;
      border: 1px solid #ffffff;
      font-family: 'RobotoFlex-Regular';
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .newguy-guide-tips {
      padding: 12px 20px;
      width: 100%;
      background: #fdfdfd;
      border-radius: 8px;
      margin-top: 22px;
      .tips-content {
        width: 100%;
        height: 100%;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 30%;
          top: -18px;
          z-index: -1;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background: #fdfdfd;
          transform: rotate(45deg);
        }

        .tips-title {
          margin: 0 auto;
          font-family: 'RobotoFlex-Regular';
          font-weight: normal;
          font-size: 15px;
          color: #333333;
        }
      }
    }

    .step1 {
      position: absolute;
      top: 280px;
      left: 16px;
      width: 343px;

      .btn-wrap {
        text-align: right;
        margin-bottom: 20px;
      }

      .newguy-guide-percent {
        padding: 12px 28px;
        background-color: #fdfdfd;
        border-radius: 8px;
        user-select: none;
        pointer-events: none;
      }
    }

    .step2 {
      position: absolute;
      top: 280px;
      left: 16px;
      width: 343px;

      .btn-wrap {
        text-align: right;
      }

      .week-commission {
        height: 96px;
        min-height: 0;
        user-select: none;
        pointer-events: none;
        margin-top: 20px;
      }

      .newguy-guide-tips {
        width: 280px;
        padding: 12px 20px;
        margin: 20px auto 0;
        .tips-content {
          &::after {
            left: 50%;
            top: -18px;
            z-index: -1;
            margin-left: -8px;
          }

          .tips-title {
            letter-spacing: -0.5px;
          }
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .amount-item .amount-count img {
    margin-right: 0;
    margin-left: 4px;
  }
}
</style>
